export const ZENDESK_CHECK_INTERVAL = 1000;
export const ZENDESK_CHECK_LIMIT = 60 * 1000; // timeout after one minute
export const CANCEL_CHAT_TAG = 'Cancel Chat';
export const CANCEL_CHAT_DEPARTMENT = 'Modify my Membership';
export const SUPPORT_CHAT_TAG = 'Support Chat';
export const SUPPORT_CHAT_DEPARTMENT = 'General Inquiry';
export const CANCEL_CHAT_FEATURE_ID = 'cancel_thru_chat';
export const SUPPORT_CHAT_FEATURE_ID = 'support_chat';

export const CANCEL_CHAT_ROUTES = ['settings/membership/update/cancel'];
export const SUPPORT_CHAT_BLACKLIST = [
  ...CANCEL_CHAT_ROUTES,
  'videos/partners',
  'settings/membership/update',
  'settings/nps-survey',
];
